export const usernameSelector = (state: any) => state.user.username;
